import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const SimpleYahooIcon = withTheme(
  ({ title, theme, width, height, viewBox = "0 0 20 19", type }) => (
    <svg
      width={width}
      height={height}
      title={title}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
    >
      <g fill="none" fillRule="evenodd">
        <g
          fill={
            type === "alternative" ? theme.onPrimaryColor : theme.primaryColor
          }
        >
          <g>
            <g transform="translate(-86 -341) translate(86 339) translate(0 2)">
              <path d="M0 4.504L3.937 4.504 6.259 10.377 8.628 4.504 12.449 4.504 6.673 18.333 2.78 18.333 4.371 14.678zM11.873 9.167L15.718 0 20 0 16.161 9.167z" />
              <ellipse cx="12.961" cy="12.417" rx="2.415" ry="2.387" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
);

export const YahooIcon = ({ type, title }) => (
  <Icon>
    <SimpleYahooIcon
      width="30"
      height="30"
      viewBox="0 0 20 19"
      title={title}
      type={type}
    />
  </Icon>
);

YahooIcon.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  title: PropTypes.string
};

YahooIcon.defaultProps = {
  title: "Yahoo Icon",
  type: "secondary"
};

export default withTheme(YahooIcon);
